import { render, staticRenderFns } from "./EditPortfolio.vue?vue&type=template&id=38368daa&scoped=true&"
import script from "./EditPortfolio.vue?vue&type=script&lang=js&"
export * from "./EditPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38368daa",
  null
  
)

export default component.exports